/**
 * Cookie consent banner
 * Shows banner on first visit, hides after acceptance or rejection
 * Stores choice in localStorage
 *
 * @package wl-theme
 */
(function() {
    'use strict';

    var STORAGE_KEY = 'wl_cookie_consent';
    var banner = document.querySelector('[data-testid="cookie-banner"]');
    var acceptBtn = document.querySelector('[data-testid="cookie-accept"]');
    var rejectBtn = document.querySelector('[data-testid="cookie-reject"]');

    if (!banner) return;

    // Already made a choice - remove banner from DOM
    if (localStorage.getItem(STORAGE_KEY)) {
        banner.remove();
        return;
    }

    // Show banner with slide-up animation
    banner.removeAttribute('hidden');
    banner.classList.add('is-visible');

    function hideBanner(choice) {
        localStorage.setItem(STORAGE_KEY, choice);
        banner.classList.remove('is-visible');
        banner.classList.add('is-hiding');
        banner.addEventListener('animationend', function() {
            banner.remove();
        }, { once: true });
    }

    if (acceptBtn) {
        acceptBtn.addEventListener('click', function() {
            hideBanner('accepted');
        });
    }

    if (rejectBtn) {
        rejectBtn.addEventListener('click', function() {
            hideBanner('rejected');
        });
    }
})();
